import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";
import { LayoutDashboard, Cable, Boxes, ShoppingBag, ClipboardCheck, UserCheck, SlidersHorizontal, LogOut, ExternalLink, PackagePlus, Bell } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/sage", label: "Sage 50 Integration", icon: Cable },
  { to: "/admin/inventory", label: "Inventory Monitor", icon: Boxes },
  { to: "/admin/products", label: "Products & Import", icon: PackagePlus },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/reconciliation", label: "Reconciliation", icon: ClipboardCheck },
  { to: "/admin/notifications", label: "Notifications Log", icon: Bell },
  { to: "/admin/applications", label: "Trade Applications", icon: UserCheck },
  { to: "/admin/settings", label: "Settings", icon: SlidersHorizontal },
];

export default function AdminLayout() {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B0C0E] lg:flex">
      <aside className="shrink-0 border-b border-[#2A2E39] bg-[#121418] lg:h-screen lg:w-72 lg:border-b-0 lg:border-r lg:sticky lg:top-0">
        <div className="flex items-center gap-3 px-6 py-5">
          <img src={LOGO_URL} alt="M&C" className="h-10 w-auto" />
          <div>
            <div className="font-serif-display text-base font-bold mc-gold-gradient">Admin</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#64748B]">Control Center</div>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col lg:overflow-visible lg:pb-0">
          {nav.map((n) => {
            const active = n.end ? pathname === n.to : pathname.startsWith(n.to);
            return (
              <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label.split(" ")[0].toLowerCase()}`}
                className={`flex shrink-0 items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${active ? "bg-[#D4AF37]/10 text-[#D4AF37]" : "text-slate-300 hover:bg-white/5 hover:text-[#D4AF37]"}`}>
                <n.icon className="h-4 w-4" /> <span className="whitespace-nowrap">{n.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="hidden px-3 lg:mt-auto lg:block lg:py-4">
          <Link to="/" className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-slate-400 hover:text-[#D4AF37]"><ExternalLink className="h-4 w-4" /> View public site</Link>
          <button onClick={async () => { await logout(); navigate("/login"); }} data-testid="admin-logout"
            className="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm text-slate-400 hover:text-rose-400"><LogOut className="h-4 w-4" /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 px-4 py-8 sm:px-8 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}
